export const SERVER_URL = "http://reconstruccion.pe"; // server
export const API_URL = SERVER_URL + "/adm/api/1.1/tables";

export const BP_PHONE_PHABLET = window.matchMedia("(max-width: 600px)");
export const BP_PHABLET_TABLET = window.matchMedia("(max-width: 900px)");
export const BP_TABLET_HD = window.matchMedia("(max-width: 1200px)");
export const BP_HD_FULLHD = window.matchMedia("(max-width: 1800px)");

export function dataMapStyles() {
  const MAP_STYLES = [
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [
        {
          weight: 1.5
        }
      ]
    },
    {
      featureType: "administrative.neighborhood",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          saturation: -85
        },
        {
          lightness: 45
        }
      ]
    },
    {
      featureType: "poi.attraction",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.park",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.school",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.sports_complex",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      stylers: [
        {
          saturation: -85
        },
        {
          lightness: 45
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "water",
      stylers: [
        {
          saturation: -85
        },
        {
          lightness: 45
        }
      ]
    }
  ];
  return MAP_STYLES;
}



// WEBPACK FOOTER //
// ./src/utils/Data.js